import React from 'react'
import 'styles/d3/mediaPlayer.scss'

const MediaPlayer = ({
  url,
  fallbackMessage = 'Your browser does not support this media format.'
}) => {
  const videoType = url
    .split('/')
    .pop()
    .split('.')
    .pop()

  const type = `video/${videoType === 'mov' ? 'webm' : videoType}`

  return (
    <div>
      <video
        controls
        disablePictureInPicture
        controlsList='nodownload noremoteplayback noplaybackrate foobar'
        className='d3-video'>
        <source src={url} type={type} />
        {fallbackMessage}
      </video>
    </div>
  )
}

export default MediaPlayer
